const getters = {
  userName: state => state.app.userName,
  screenItemList: state => state.screen.screenItemList,
  userInfo: state => state.userInfo.userInfo,
}
export default getters
